import React, { useState } from "react";
import { SearchContextProvider, useSearch } from "./SearchContext";
import { Text } from "./Filter";

import { FaSearch, FaArrowRight, FaWindowClose } from "react-icons/fa";

export interface ITextWidgetSearchProps {
  /**
   * Classes to add to the search container div.
   */
  className?: string;
  /**
   * Classes to add in the toggled open state.
   */
  openClassName?: string;
  /**
   * Classes to add to the text search input.
   */
  inputClassName?: string;
  /**
   * Text search input field label/placeholder
   */
  placeholder: string;
  /**
   * Function to call on click of the submit arrow
   */
  onSubmit?: (filters: {}) => void;
  /**
   * Direction to expand/cover when toggled
   */
  expand?: "left" | "right";
}

const ButtonComponent: React.FC<{
  onSubmit?: (filters: {}) => void;
  buttonClassName?: string;
}> = ({ onSubmit, buttonClassName }) => {
  const context = useSearch();
  return (
    <button
      onClick={() => {
        onSubmit && onSubmit(context.currentFilterValues || {});
      }}
      className="p-2.5"
    >
      <FaArrowRight />
      <span className="sr-only">Submit</span>
    </button>
  );
};

export const TextWidgetSearch: React.FC<ITextWidgetSearchProps> = ({
  className = "",
  openClassName = "",
  inputClassName = "",
  placeholder,
  onSubmit,
  expand = "right",
}) => {
  const [isToggledOpen, setToggle] = useState(false);
  const toggle = () => setToggle(!isToggledOpen);
  return (
    <SearchContextProvider>
      <div
        className={`textWidgetSearch inline-block overflow-visible ${isToggledOpen ? openClassName : ""
          }`}
      >
        <div
          className={`leading-none flex justify-start relative align-center w-full ${className}`}
        >
          <button
            onClick={toggle}
            className={`p-2.5 ${isToggledOpen ? "text-transparent" : ""}`}
          >
            <FaSearch />
            <span className="sr-only">Search</span>
          </button>
          {isToggledOpen && (
            <div
              tabIndex={0}
              className={`border-l-button-text inline-flex absolute top-0 bg-body-bg ${expand == "right" ? "left-0" : "right-0"
                } ${className}`}
            >
              <button onClick={toggle} className={`p-2.5`}>
                <FaWindowClose />
                <span className="sr-only">Search</span>
              </button>
              <Text
                label={placeholder || ""}
                param="text"
                className="self-center"
                placeholder={placeholder}
                inputClassName={inputClassName}
                onSubmit={onSubmit}
                resolver={(arg: any, text) => {
                  return true;
                }}
              />
              <ButtonComponent onSubmit={onSubmit} buttonClassName="p-2.5" />
            </div>
          )}
        </div>
      </div>
    </SearchContextProvider>
  );
};

export default TextWidgetSearch;
